import React from "react";
import { VIEW_BUNDLES, PRICING_LIST_PLANS } from "./screen";

export default function PricingBreadcrumbs({ breadcrumbs = [], currentPage, setScreen, planData }) {
  // If no breadcrumbs are passed, generate them based on current context
  const generatedBreadcrumbs = breadcrumbs.length > 0 ? breadcrumbs : (() => {
    const crumbs = [];
    
    // Always start with Bundle Management (except when in plan history from pricing view)
    if (!planData || currentPage !== 'plan-history') {
      crumbs.push({ label: "Bundle Management", onClick: () => setScreen && setScreen(VIEW_BUNDLES) });
    }
    
    // Add Bundle Pricing breadcrumb
    crumbs.push({ 
      label: "Bundle Pricing",
      onClick: planData ? null : (() => setScreen && setScreen(PRICING_LIST_PLANS))
    });
    
    // Add current page breadcrumb based on context
    if (currentPage === 'plan-history') {
      crumbs.push({ label: "Plan History" });
    } else if (currentPage === 'retired-plans') {
      crumbs.push({ label: "Retired Plans" });
    } else if (currentPage === 'add-plan') {
      crumbs.push({ label: "Add a Plan" });
    } else if (currentPage === 'edit-plan') {
      crumbs.push({ label: "Edit a Plan" });
    }
    
    return crumbs;
  })();

  return (
    <div>
      {generatedBreadcrumbs.map((crumb, idx) => {
        return (
          <span
            key={idx}
            className={`bundle-pricing-breadcrumb${
              crumb.onClick ? " clickable" : ""
            }`}
            onClick={crumb.onClick}
            style={{
              cursor: crumb.onClick ? "pointer" : "default",
              color: crumb.onClick ? "#5E2368" : "inherit",
              textDecoration: "none",
              fontWeight: crumb.onClick ? "600" : "400",
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0px",
              fontStyle: "normal",
            }}
          >
            {crumb.label}
            {idx < generatedBreadcrumbs.length - 1 && " > "}
          </span>
        );
      })}
    </div>
  );
}
